<div class="widget-products widget mb-4">
    <h4 class="widget__title">{{ header | translate }}</h4>
    <div class="widget-products__list">
        <div *ngFor="let vendor of vendors" class="widget-products__item  gap-4">
            <div class="image-container">
                <a [routerLink]="['vendor', vendor.seo?.slug]" class="image-link">
                    <img class="image" [src]="vendor?.design?.logo?.url" alt="">
                </a>
            </div>
            <!-- <div class="widget-products__image">
                <div class="product-image">

                </div>
            </div> -->
            <div class="widget-products__info">
                <div class="widget-products__name">
                    <a [routerLink]="['/vendor', vendor.seo?.slug]">{{ translateHlper.localize(vendor.name) }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
